(function () {
  'use strict';

  function extractErrorText(err) {
    var parts = [];
    if (err && err.responseBody) {
      if (err.responseBody.description) parts.push(String(err.responseBody.description));
      if (err.responseBody.message) parts.push(String(err.responseBody.message));
      if (err.responseBody.errors) {
        if (typeof err.responseBody.errors === 'string') parts.push(err.responseBody.errors);
        else { try { parts.push(JSON.stringify(err.responseBody.errors)); } catch (_) {} }
      }
    }
    if (err && err.description) parts.push(String(err.description));
    if (err && err.message) parts.push(String(err.message));
    return parts.join(' ').replace(/[\u2018\u2019]/g, "'").trim();
  }

  function getErrorStatus(err) {
    return Number(
      (err && (err.shopifyStatus || err.status)) ||
        (err && err.responseBody && err.responseBody.status) ||
        0
    );
  }

  function parseCartStockError(err, opts) {
    if (!err) return null;
    opts = opts || {};
    var operation = opts.operation || 'change';
    var requestedQty = typeof opts.requestedQty === 'number' ? opts.requestedQty : null;
    var previousQty = typeof opts.previousQty === 'number' ? opts.previousQty : null;

    var status = getErrorStatus(err);
    var raw = extractErrorText(err);
    var lowered = raw.toLowerCase();

    var isRateLimit =
      status === 429 ||
      /(^|\b)(1015|429)(\b|$)|rate\s*limit|too\s+many\s+requests/.test(lowered);
    if (isRateLimit) {
      return { kind: 'rate-limit', rateLimited: true, raw: raw, allowedQty: null,
               soldOut: false, alreadyInCart: false, cantAddMore: false, staleLine: false };
    }

    var isStaleLine =
      status === 400 ||
      /no valid id or line parameter|line item not found|line .* invalid|cart error/.test(lowered);

    var stockLike =
      status === 422 ||
      /can't add more|cannot add more|cant add more|can not add more|already in your cart|are in your cart|is in your cart|sold out|out of stock|unavailable|you can only add|more than\s+\d+|only\s+\d+\s+(left|available|remaining)|due to availability|\d+\s+items?\s+(?:were|was)\s+added/.test(lowered);

    if (!stockLike && !isStaleLine) return null;

    var soldOut = /sold out|out of stock|unavailable/.test(lowered);
    var alreadyInCart = /already in your cart|are in your cart|is in your cart/.test(lowered);
    var cantAddMore = /can't add more|cannot add more|cant add more|can not add more|more than\s+\d+/.test(lowered);

    var explicitAllowed = null;
    var qtyPatterns = [
      /\bonly\s+(\d+)\s+items?\s+(?:were|was|have been)\s+added\b/i,
      /\bonly\s+(\d+)\s+(?:left|available|remaining)\b/i,
      /\b(\d+)\s+(?:left|available|remaining)\b/i,
      /\bonly\s+add\s+(\d+)\b/i,
      /\byou can only add\s+(\d+)\b/i,
      /\bmore than\s+(\d+)\b/i,
      /\ball\s+(\d+)\b.{0,40}\bin your cart\b/i,
      /\b(\d+)\s+(?:are|is)\s+in\s+your\s+cart\b/i,
      /\ball\s+(\d+)\s+(?:left|available|remaining|in stock)\b/i,
    ];
    for (var i = 0; i < qtyPatterns.length; i++) {
      var match = raw.match(qtyPatterns[i]);
      if (!match) continue;
      var n = parseInt(match[1], 10);
      if (!isNaN(n) && n >= 0) { explicitAllowed = n; break; }
    }

    var allowedQty = explicitAllowed;

    if (operation === 'add') {
      if (alreadyInCart) {
        allowedQty = 0;
      } else if (cantAddMore) {
        allowedQty = 0;
      }
    } else {
      var prevQty = previousQty;
      var isIncreaseAttempt = prevQty != null
        ? requestedQty > prevQty
        : (requestedQty != null && requestedQty > 1);
      if (allowedQty === null && (alreadyInCart || cantAddMore) &&
          prevQty != null && isIncreaseAttempt) {
        allowedQty = prevQty;
      }
    }

    return {
      kind: isStaleLine && !stockLike ? 'stale-line' : 'stock',
      allowedQty: allowedQty,
      soldOut: soldOut,
      alreadyInCart: alreadyInCart,
      cantAddMore: cantAddMore,
      rateLimited: false,
      staleLine: isStaleLine,
      raw: raw
    };
  }

  function stockErrorMessage(constraint, context) {
    if (!constraint) return null;
    context = context || {};
    var op = context.operation || 'change';

    if (constraint.rateLimited) {
      return {
        message: 'Too many requests in a short time. Please wait a few seconds and try again.',
        toastType: 'error'
      };
    }

    if (constraint.kind === 'stale-line' && !constraint.soldOut && !constraint.cantAddMore && !constraint.alreadyInCart) {
      return {
        message: 'Cart changed in the background. Please try that quantity update again.',
        toastType: 'info'
      };
    }

    if (constraint.soldOut) {
      return { message: 'This item is sold out for the selected option.', toastType: 'error' };
    }

    if (op === 'add' && constraint.alreadyInCart) {
      return { message: 'You already have the maximum available in your cart.', toastType: 'info' };
    }

    if (op === 'add' && constraint.cantAddMore) {
      return { message: 'You already have the maximum quantity in your cart.', toastType: 'info' };
    }

    var allowed = constraint.allowedQty;
    var reqQty = context.requestedQty;
    if (typeof allowed === 'number' && allowed > 0) {
      var msg;
      if (op === 'add') {
        if (typeof reqQty === 'number' && reqQty > allowed) {
          msg = 'Only ' + allowed + ' of the ' + reqQty + ' requested are available and have been added to your cart.';
        } else {
          msg = 'Only ' + allowed + ' available and have been added to your cart.';
        }
      } else {
        msg = 'Only ' + allowed + ' available \u2014 quantity has been adjusted.';
      }
      return { message: msg, toastType: 'info' };
    }

    if (typeof allowed === 'number' && allowed === 0) {
      return { message: 'No more stock is available for this item.', toastType: 'error' };
    }

    if (constraint.alreadyInCart || constraint.cantAddMore) {
      return { message: 'No more stock is available for this item.', toastType: 'error' };
    }

    return { message: 'No more stock is available for this item.', toastType: 'error' };
  }

  window._ddCartErrors = {
    extractErrorText: extractErrorText,
    getErrorStatus: getErrorStatus,
    parseCartStockError: parseCartStockError,
    stockErrorMessage: stockErrorMessage
  };
})();
